import { render, staticRenderFns } from "./ColumnChart.vue?vue&type=template&id=36f6f71e&scoped=true&"
import script from "./ColumnChart.vue?vue&type=script&lang=js&"
export * from "./ColumnChart.vue?vue&type=script&lang=js&"
import style0 from "./ColumnChart.vue?vue&type=style&index=0&id=36f6f71e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36f6f71e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/runner/_work/studio/studio/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRow } from 'vuetify/lib'
installComponents(component, {VRow})
